export const checkStreamStatus = (stream: MediaStream) => {
  const isMediaStream = stream instanceof MediaStream
  const tracks = isMediaStream ? stream.getTracks() : []

  return {
    streamActive: isMediaStream && stream.active,
    tracksInfo: tracks.map((track) => {
      return {
        kind: track.kind,
        label: track.label,
        muted: track.muted,
        enabled: track.enabled,
        deviceId: track.getSettings().deviceId,
        readyState: track.readyState,
      }
    }),
  }
}
